export const getUrlParam = function (paramName, urlText = window.location.href) {
    if (urlText) {
        const url = new URL(urlText);
        return url.searchParams.get(paramName);
    }
    return '';
};

export const setUrlParam = function (key, value) { //need context (call,apply or etc)
    const query = {
        ...this.$route.query,
    };
    query[key] = value;
    this.$router.replace({
        query,
    }).catch(() => {
    });
};
export const deleteUrlParam = function (key) { //need context (call,apply or etc)
    const query = {
        ...this.$route.query,
    };
    delete query[key];
    this.$router.replace({
        query,
    }).catch(() => {
    });
};

export const getOrigin = function () {
    return window.location.origin;
};